const BASE = process.env.REACT_APP_API_URL;

async function request(method, path, body) {
    const token = sessionStorage.getItem('access_token');

    const options = {
        method,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        ...(body ? { body: JSON.stringify(body) } : {}),
    };

    let res = await fetch(BASE + path, options);

    if (res.status === 401 && path !== '/api/admin/login') {
        const refreshRes = await fetch(BASE + '/api/admin/refresh', {
            method: 'POST',
            credentials: 'include',
        });

        if (refreshRes.ok) {
            const refreshData = await refreshRes.json();
            sessionStorage.setItem('access_token', refreshData.data.access_token);
            options.headers.Authorization = `Bearer ${refreshData.data.access_token}`;
            res = await fetch(BASE + path, options);
        } else {
            sessionStorage.clear();
            window.location.href = '/login';
            return null;
        }
    }

    return res.json();
}

export const apiGet    = (path)        => request('GET',    path);
export const apiPost   = (path, body)  => request('POST',   path, body);
export const apiPatch  = (path, body)  => request('PATCH',  path, body);
export const apiDelete = (path)        => request('DELETE', path);

export async function apiDownload(path, filename) {
    const token = sessionStorage.getItem('access_token');
    const res   = await fetch(BASE + path, {
        credentials: 'include',
        headers: { Authorization: `Bearer ${token}` },
    });
    const blob  = await res.blob();
    const url   = URL.createObjectURL(blob);
    const a     = document.createElement('a');
    a.href      = url;
    a.download  = filename;
    a.click();
    URL.revokeObjectURL(url);
}
